import { Service } from "../../providers/types";

export const sumAmountOfServiceProducts = (
  serviceProducts: Service[]
): number => {
  return serviceProducts.reduce((total, current) => {
    return total + current.product.price * current.quantity;
  }, 0);
};
